import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

import { AuthDataModel } from '../app/models/auth.data.model';
import { LocalStorageEnum } from '../app/enums/local.storage.enum';
import { Headers } from '@angular/http';

@Injectable()
export class AuthService {
    private localStorageAuthData: string = LocalStorageEnum[LocalStorageEnum.authData];

    constructor(private localStorageService: LocalStorageService) { }

    cleanAuthData(): void {
        this.localStorageService.store(this.localStorageAuthData, {});
    }

    setAuthData(authData: string): void {
        var authDataSanitized = this.sanitizeData(authData);
        var authDataJson = JSON.parse(authDataSanitized);
        var authDataModel = new AuthDataModel(authDataJson.access_token, authDataJson.userName,
            JSON.parse(authDataJson.type), authDataJson.userPermissions == "" ? "" : JSON.parse(authDataJson.userPermissions), authDataJson.fullName, authDataJson.resetPassword, authDataJson.userId);
        this.localStorageService.store(this.localStorageAuthData, authDataModel);
    }

    private sanitizeData(data: string): string {
        var authDataSanitized = data
            .replace('.expires:', 'expires:')
            .replace('.issued:', 'issued:')
            .replace('Access-Control-Allow-Origin:', 'accessControlAllowOrigin:')
            .replace('as:clientId:', 'asClientId:');

        return authDataSanitized;
    }

    getAuthData(): AuthDataModel {
        var authDataLocalStorage = this.localStorageService.retrieve(this.localStorageAuthData);
        var authData: AuthDataModel = authDataLocalStorage;

        return authData;
    }

    private castStringToAuthData(data: string): AuthDataModel {
        var authDataJson = JSON.parse(data);
        var authData = new AuthDataModel(authDataJson.access_token, authDataJson.userName,
            JSON.parse(authDataJson.type), JSON.parse(authDataJson.userPermissions), authDataJson.fullName, authDataJson.resetPassword, authDataJson.userId);

        return authData;
    }

    getUserName(): string {
        var authData = this.getAuthData();

        return authData.userName;
    }

    getUserId(): number {
        var authData = this.getAuthData();

        return authData.userId;
    }

    getAccessToken(): string {
        var authData = this.getAuthData();

        return authData.access_token;
    }

    userIsInRole(roleName: string) {
        var authData = this.getAuthData();
        var role = authData.type.filter(function (ele) { return ele == roleName });

        return role && role.length > 0;
    }

    userHasPermission(permissionName: string): boolean {
        if (!permissionName) return true;
        var authData = this.getAuthData();
        if (authData.userPermissions == undefined || authData.userPermissions.toString() == "") return false;
        var permission = authData.userPermissions.filter(function (ele) { return ele == permissionName });
        return permission && permission.length > 0;
    }

    isUserAuthenticated() {
        var authData = this.getAuthData();

        return authData && authData.access_token;
    }

    getHeader(): Headers{
        return new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.getAccessToken()}` });
    }
}


// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/services/auth.service.ts